import createActions from "helpers/actionCreator"
import { createReducer } from "reduxsauce"
import { get } from "lodash"
import { call, getContext, select, takeLatest } from "redux-saga/effects"
import { computeUpdatedFilters } from "helpers/filters"
import { NORMALIZATION } from "helpers/segments"
import { Types as LoaderTypes } from "model/data"
import { getPortfolio } from "modules/portfolio-root/selectors/portfolios"

export const { Types, Creators } = createActions("ompnt/modules/intraday", {
  setGrouping: {
    props: ["grouping"],
    track: true,
    trackType: "intraday-assets-grouping-option-selected",
    trackPayload: ({ grouping }) => {
      let by
      if (grouping) {
        by = grouping.classificationId
          ? `${grouping.classificationId} - ${grouping.id}` : grouping.id
      }
      return { by }
    },
  },
  updateFilters: {
    props: ["filter"],
    track: true,
    trackType: "intraday-assets-segment-filters-update",
    trackPayload: ({ filter }) => ({ filter }),
  },
  setNormalization: {
    props: ["normalization"],
    track: true,
    trackType: "intraday-assets-normalization-selection",
    trackPayload: ({ normalization }) => ({ normalization }),
  },
  toggleFilters: [],
  selectScreen: ["screen"],
})

const DEFAULT_STATE = {
  grouping: null,
  normalization: NORMALIZATION.CONTRIBUTION,
  filter: null,
  filtersVisible: false,
}

function handleLoadSuccess(state, action) {
  if (action.resource === "portfolio") {
    return { ...DEFAULT_STATE }
  }

  return state
}

function handleSetGrouping(state, { grouping }) {
  return { ...state, grouping }
}

function handleUpdateFilters(state, { filter }) {
  return { ...state, ...computeUpdatedFilters(filter) }
}

function handleSetNormalization(state, { normalization }) {
  return { ...state, normalization }
}

function handleToggleFilters(state) {
  return { ...state, filtersVisible: !state.filtersVisible }
}

export default createReducer(DEFAULT_STATE, {
  [LoaderTypes.LOAD_SUCCESS]: handleLoadSuccess,
  [Types.SET_GROUPING]: handleSetGrouping,
  [Types.SET_NORMALIZATION]: handleSetNormalization,
  [Types.UPDATE_FILTERS]: handleUpdateFilters,
  [Types.TOGGLE_FILTERS]: handleToggleFilters,
})

function* handleSelectScreen({ screen }) {
  const [account, portfolio] = yield select(state => [
    get(state, "global.selected.account"),
    getPortfolio(state),
  ])

  const { navigate } = yield getContext("router")
  yield call(navigate, `/${account}/p/${portfolio.shortId}/analyze/intraday/${screen}`)
}

export function* saga() {
  yield takeLatest(Types.SELECT_SCREEN, handleSelectScreen)
}
